
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as cG9zdGhvZy1qcw from 'posthog-js';
import * as d2FzbTpqcy1zdHJpbmc from './Exampia-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_cG9zdGhvZy1qcw_ = cG9zdGhvZy1qcw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.longToExternref' : (x) => x,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.assign_$external_fun' : (_this, p0) => _this.assign(p0),
    'org.w3c.dom.document_$external_prop_getter' : (_this) => _this.document,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.cookie_$external_prop_getter' : (_this) => _this.cookie,
    'org.w3c.dom.cookie_$external_prop_setter' : (_this, v) => _this.cookie = v,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.className_$external_prop_setter' : (_this, v) => _this.className = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.sessionStorage_$external_prop_getter' : (_this) => _this.sessionStorage,
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.back_$external_fun' : (_this, ) => _this.back(),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.querySelector_$external_fun_1' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.HTMLFormElement_$external_class_instanceof' : (x) => x instanceof HTMLFormElement,
    'org.w3c.dom.HTMLFormElement_$external_class_get' : () => HTMLFormElement,
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.key_$external_fun' : (_this, p0) => _this.key(p0),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.disabled_$external_prop_setter' : (_this, v) => _this.disabled = v,
    'org.w3c.dom.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'org.w3c.dom.required_$external_prop_setter' : (_this, v) => _this.required = v,
    'org.w3c.dom.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.HTMLAnchorElement_$external_class_instanceof' : (x) => x instanceof HTMLAnchorElement,
    'org.w3c.dom.HTMLAnchorElement_$external_class_get' : () => HTMLAnchorElement,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'com.posthog.kmp.createJsObject' : () => ({}),
    'com.posthog.kmp.setJsProperty' : (target, key, value) => { target[key] = value; },
    'com.posthog.kmp.setBeforeSendCallback' : (target, callback) => { target.before_send = callback; },
    'com.posthog.kmp.overrideSdkInfo' : (instance, sdkName, sdkVersion) => { instance._overrideSDKInfo?.(sdkName, sdkVersion); },
    'com.posthog.kmp.createJsDate' : (timestamp) => new Date(timestamp),
    'com.posthog.kmp.isJsString' : (value) => typeof value === 'string',
    'com.posthog.kmp.logWasmError' : (operation, message) => { console.error('[PostHog] ' + operation + ' failed', message); },
    'com.posthog.kmp.isJsArray' : (value) => Array.isArray(value),
    'com.posthog.kmp.jsArrayLength' : (value) => value.length,
    'com.posthog.kmp.jsArrayItem' : (value, index) => value[index],
    'com.posthog.kmp.jsStringValue' : (value) => value,
    'com.posthog.kmp.numberToJsAny' : (value) => value,
    'com.posthog.kmp.jsBooleanValue' : (value) => value,
    'com.posthog.kmp.isJsBoolean' : (value) => typeof value === 'boolean',
    'com.posthog.kmp.isJsNumber' : (value) => typeof value === 'number',
    'com.posthog.kmp.isPlainJsObject' : (value) => typeof value === 'object' && value !== null && (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null),
    'com.posthog.kmp.getJsProperty' : (target, key) => target[key],
    'com.posthog.kmp.createJsArray' : () => ([]),
    'com.posthog.kmp.appendJsArray' : (target, value) => { target.push(value); },
    'com.posthog.kmp.jsNumberValue' : (value) => value,
    'com.posthog.kmp.jsObjectKeys' : (value) => Object.keys(value),
    'com.posthog.kmp.isJsNullProperty' : (target, key) => target[key] === null,
    'com.posthog.kmp.init_$external_fun' : (_this, p0, p1) => _this.init(p0, p1),
    'com.posthog.kmp.capture_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.capture(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'com.posthog.kmp.reset_$external_fun' : (_this, ) => _this.reset(),
    'com.posthog.kmp.opt_out_capturing_$external_fun' : (_this, ) => _this.opt_out_capturing(),
    'com.posthog.kmp.opt_in_capturing_$external_fun' : (_this, ) => _this.opt_in_capturing(),
    'com.posthog.kmp.setPersonProperties_$external_fun' : (_this, p0, p1, isDefault0) => _this.setPersonProperties(p0, isDefault0 ? undefined : p1, ),
    'com.posthog.kmp.posthog_$external_prop_getter' : () => _ref_cG9zdGhvZy1qcw_.posthog,
    'com.exampia.core.audio.jsEnsureEngine' : (id) => {
        if (!window._appAudioEngines) window._appAudioEngines = {};
        if (!window._appAudioEngines[id]) {
            window._appAudioEngines[id] = {
                playCtx: null,
                nextStartTime: 0,
                sources: [],
                recCtx: null,
                stream: null,
                processor: null,
                recording: false,
                pendingBytes: [],
                micQueue: []
            };
        }
    },
    'com.exampia.core.audio.jsStartMicCapture' : (id) => {
        var engine = window._appAudioEngines && window._appAudioEngines[id];
        if (!engine || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return;
        engine.recording = true;
        engine.pendingBytes = [];
        engine.micQueue = [];
        navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true,
                sampleRate: 16000,
                channelCount: 1
            }
        }).then(function(stream) {
            if (!engine.recording) {
                stream.getTracks().forEach(function(t) { t.stop(); });
                return;
            }
            engine.stream = stream;
            var AudioCtx = window.AudioContext || window.webkitAudioContext;
            var recCtx = new AudioCtx({ sampleRate: 16000 });
            engine.recCtx = recCtx;
            if (recCtx.state === 'suspended') {
                recCtx.resume().catch(function() {});
            }
            var source = recCtx.createMediaStreamSource(stream);
            var processor = recCtx.createScriptProcessor(2048, 1, 1);
            var silentGain = recCtx.createGain();
            silentGain.gain.value = 0;
            engine.processor = processor;
            processor.onaudioprocess = function(e) {
                if (!engine.recording) return;
                var input = e.inputBuffer.getChannelData(0);
                var actualRate = recCtx.sampleRate || 16000;
                var ratio = actualRate / 16000.0;
                var outLen = ratio === 1 ? input.length : Math.floor(input.length / ratio);
                for (var i = 0; i < outLen; i++) {
                    var idx = ratio === 1 ? i : Math.min(input.length - 1, Math.floor(i * ratio));
                    var sample = Math.max(-1.0, Math.min(1.0, input[idx]));
                    var s = sample < 0 ? (sample * 32768) | 0 : (sample * 32767) | 0;
                    engine.pendingBytes.push(s & 0xff, (s >> 8) & 0xff);
                }
                while (engine.pendingBytes.length >= 3200) {
                    var chunk = engine.pendingBytes.splice(0, 3200);
                    var bin = '';
                    for (var j = 0; j < chunk.length; j++) {
                        bin += String.fromCharCode(chunk[j]);
                    }
                    engine.micQueue.push(btoa(bin));
                }
            };
            source.connect(processor);
            processor.connect(silentGain);
            silentGain.connect(recCtx.destination);
        }).catch(function(e) {
            console.warn('Microphone capture error:', e);
            engine.recording = false;
        });
    },
    'com.exampia.core.audio.jsPollMicChunk' : (id) => {
        var engine = window._appAudioEngines && window._appAudioEngines[id];
        if (engine && engine.micQueue && engine.micQueue.length > 0) {
            return engine.micQueue.shift();
        }
        return '';
    },
    'com.exampia.core.audio.jsStopMicCapture' : (id) => {
        var engine = window._appAudioEngines && window._appAudioEngines[id];
        if (!engine) return;
        engine.recording = false;
        engine.pendingBytes = [];
        engine.micQueue = [];
        if (engine.processor) {
            try { engine.processor.disconnect(); } catch (e) {}
            engine.processor = null;
        }
        if (engine.stream) {
            try {
                engine.stream.getTracks().forEach(function(t) { t.stop(); });
            } catch (e) {}
            engine.stream = null;
        }
        if (engine.recCtx) {
            try { engine.recCtx.close(); } catch (e) {}
            engine.recCtx = null;
        }
    },
    'com.exampia.core.audio.jsEnqueuePcm24k' : (id, base64) => {
        if (!window._appAudioEngines || !window._appAudioEngines[id]) return;
        var engine = window._appAudioEngines[id];
        try {
            var AudioCtx = window.AudioContext || window.webkitAudioContext;
            if (!AudioCtx) return;
            if (!engine.playCtx) {
                engine.playCtx = new AudioCtx({ sampleRate: 24000 });
            }
            var ctx = engine.playCtx;
            if (ctx.state === 'suspended') {
                ctx.resume().catch(function() {});
            }
            var bin = atob(base64);
            var sampleCount = (bin.length / 2) | 0;
            if (sampleCount <= 0) return;
            var audioBuffer = ctx.createBuffer(1, sampleCount, 24000);
            var channelData = audioBuffer.getChannelData(0);
            for (var i = 0; i < sampleCount; i++) {
                var b0 = bin.charCodeAt(i * 2) & 0xff;
                var b1 = bin.charCodeAt(i * 2 + 1) & 0xff;
                var s = b0 | (b1 << 8);
                if (s >= 32768) s -= 65536;
                channelData[i] = s / 32768.0;
            }
            var source = ctx.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(ctx.destination);
            var startAt = Math.max(ctx.currentTime, engine.nextStartTime || 0);
            engine.nextStartTime = startAt + audioBuffer.duration;
            engine.sources.push(source);
            source.onended = function() {
                var idx = engine.sources.indexOf(source);
                if (idx !== -1) engine.sources.splice(idx, 1);
            };
            source.start(startAt);
        } catch (e) {
            console.warn('PCM playback error:', e);
        }
    },
    'com.exampia.core.audio.jsFlushPlayback' : (id) => {
        var engine = window._appAudioEngines && window._appAudioEngines[id];
        if (!engine) return;
        var active = engine.sources.slice();
        engine.sources = [];
        for (var i = 0; i < active.length; i++) {
            try { active[i].stop(); } catch (e) {}
        }
        engine.nextStartTime = 0;
    },
    'com.exampia.core.audio.jsReleaseEngine' : (id) => {
        var engine = window._appAudioEngines && window._appAudioEngines[id];
        if (!engine) return;
        if (engine.playCtx) {
            try { engine.playCtx.close(); } catch (e) {}
            engine.playCtx = null;
        }
        delete window._appAudioEngines[id];
    },
    'com.exampia.core.audio.jsGetAudioDuration' : (id) => {
        var a = window._appAudios && window._appAudios[id];
        if (a && a.duration > 0 && !isNaN(a.duration)) {
            return a.duration;
        }
        return 0.0;
    },
    'com.exampia.core.audio.jsCreateAudio' : (id, url) => {
        if (!window._appAudios) window._appAudios = {};
        var a = window._appAudios[id];
        if (!a) {
            a = new Audio(url);
            window._appAudios[id] = a;
        } else if (a.src !== url) {
            a.src = url;
        }
        a.onloadedmetadata = function() {
            if (typeof a._pendingSeek === 'number' && a.duration > 0 && !isNaN(a.duration)) {
                a.currentTime = a.duration * a._pendingSeek;
                a._pendingSeek = null;
            }
        };
    },
    'com.exampia.core.audio.jsPlayAudio' : (id) => {
        if (window._appAudios) {
            for (var key in window._appAudios) {
                if (key !== id && window._appAudios[key]) {
                    window._appAudios[key].pause();
                }
            }
        }
        if (window._appAudios && window._appAudios[id]) {
            var a = window._appAudios[id];
            a._playFailed = false;
            a._lastError = null;
            var p = a.play();
            if (p && typeof p.catch === 'function') {
                p.catch(function(e) {
                    console.warn('Audio play error: ', e);
                    a._playFailed = true;
                    a._lastError = (e && (e.name === 'NotAllowedError' || (e.message && e.message.indexOf('user gesture') !== -1)))
                        ? 'autoplay_blocked'
                        : ((e && e.message) ? e.message : 'playback_error');
                });
            }
        }
    },
    'com.exampia.core.audio.jsPauseAudio' : (id) => {
        if (window._appAudios && window._appAudios[id]) {
            window._appAudios[id].pause();
        }
    },
    'com.exampia.core.audio.jsStopAudio' : (id) => {
        if (window._appAudios && window._appAudios[id]) {
            window._appAudios[id].pause();
            window._appAudios[id].currentTime = 0;
            window._appAudios[id]._pendingSeek = null;
        }
    },
    'com.exampia.core.audio.jsSeekAudio' : (id, progress) => {
        var a = window._appAudios && window._appAudios[id];
        var clamped = Math.max(0.0, Math.min(1.0, progress));
        if (a && a.duration > 0 && !isNaN(a.duration)) {
            a._pendingSeek = null;
            a.currentTime = a.duration * clamped;
        } else if (a) {
            a._pendingSeek = clamped;
        }
    },
    'com.exampia.core.audio.jsReleaseAudio' : (id) => {
        if (window._appAudios && window._appAudios[id]) {
            window._appAudios[id].pause();
            window._appAudios[id].src = '';
            delete window._appAudios[id];
        }
    },
    'com.exampia.core.audio.jsGetAudioError' : (id) => {
        var a = window._appAudios && window._appAudios[id];
        if (a && a._playFailed && a._lastError) {
            var err = a._lastError;
            a._playFailed = false;
            a._lastError = null;
            return err;
        }
        return null;
    },
    'com.exampia.core.audio.jsGetAudioProgress' : (id) => {
        var a = window._appAudios && window._appAudios[id];
        if (a && a.duration > 0 && !isNaN(a.duration)) {
            if (typeof a._pendingSeek === 'number') {
                a.currentTime = a.duration * a._pendingSeek;
                a._pendingSeek = null;
            }
            return a.currentTime / a.duration;
        }
        return -1.0;
    },
    'com.exampia.core.audio.jsIsAudioEnded' : (id) => {
        var a = window._appAudios && window._appAudios[id];
        return !!(a && a.ended);
    },
    'com.exampia.core.audio.jsConnectWs' : (id, url) => {
        if (!window._appLiveWs) window._appLiveWs = {};
        if (window._appLiveWs[id] && window._appLiveWs[id].ws) {
            try { window._appLiveWs[id].ws.close(1000, 'Reconnecting'); } catch (e) {}
        }
        var entry = {
            ws: null,
            events: []
        };
        window._appLiveWs[id] = entry;
        try {
            var ws = new WebSocket(url);
            ws.binaryType = 'arraybuffer';
            entry.ws = ws;
            ws.onopen = function() {
                entry.events.push('O:');
            };
            ws.onmessage = function(event) {
                if (typeof event.data === 'string') {
                    entry.events.push('M:' + event.data);
                } else if (event.data instanceof ArrayBuffer) {
                    var text = new TextDecoder('utf-8').decode(new Uint8Array(event.data));
                    entry.events.push('M:' + text);
                } else if (typeof Blob !== 'undefined' && event.data instanceof Blob) {
                    event.data.text().then(function(t) {
                        entry.events.push('M:' + t);
                    }).catch(function() {});
                }
            };
            ws.onerror = function() {
                entry.events.push('E:WebSocket connection error');
            };
            ws.onclose = function(event) {
                var code = event.code || 1000;
                var reason = event.reason || '';
                entry.events.push('C:' + code + ':' + reason);
            };
        } catch (e) {
            entry.events.push('E:' + (e && e.message ? e.message : 'Failed to open WebSocket'));
        }
    },
    'com.exampia.core.audio.jsPollWsEvent' : (id) => {
        var entry = window._appLiveWs && window._appLiveWs[id];
        if (entry && entry.events && entry.events.length > 0) {
            return entry.events.shift();
        }
        return '';
    },
    'com.exampia.core.audio.jsSendWsText' : (id, payload) => {
        var entry = window._appLiveWs && window._appLiveWs[id];
        if (entry && entry.ws && entry.ws.readyState === 1) {
            try {
                entry.ws.send(payload);
            } catch (e) {
                console.warn('WebSocket send error:', e);
            }
        }
    },
    'com.exampia.core.audio.jsCloseWs' : (id, code, reason) => {
        var entry = window._appLiveWs && window._appLiveWs[id];
        if (entry) {
            if (entry.ws) {
                try { entry.ws.close(code, reason); } catch (e) {}
                entry.ws = null;
            }
            delete window._appLiveWs[id];
        }
    },
    'com.exampia.core.consent.firebaseHostingCountryPromise' : () => window.exampiaPrivacyRegionPromise,
    'com.exampia.core.consent.countryCodeFromJs' : (value) => typeof value === 'string' ? value : null,
    'com.exampia.core.consent.browserGlobalPrivacyControlEnabled' : () => navigator.globalPrivacyControl === true,
    'com.exampia.core.local.jsIsDbRestored' : () => !!(window._sqlDbIsRestored),
    'com.exampia.core.local.jsSqlExec' : (sql, paramsJson) => String(window._sqlExec ? window._sqlExec(sql, paramsJson) : 0),
    'com.exampia.core.local.jsSqlQuery' : (sql, paramsJson) => (window._sqlQuery ? window._sqlQuery(sql, paramsJson) : '[]'),
    'com.exampia.core.data.repo.currentPlatformIanaTimezone' : () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skia.webext.skikoArrayBuffer' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'org.jetbrains.skia.webext.copyBuffer' : (src, dst, dstOffset) => { 
            var dstView = new Uint8Array(dst);
            var srcView = new Uint8Array(src);
            dstView.set(srcView, dstOffset);
         },
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.fetch.fetch' : (url) => fetch(url),
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'com.exampia.core.ui.motion.jsPrefersReducedMotion' : () => 
        (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) === true
    ,
    'com.exampia.core.ui.platform.jsCheckMicPermissionPromise' : () => 
        new Promise(function(resolve) {
            var probeWithLiveAccess = function() {
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    resolve('UNAVAILABLE');
                    return;
                }
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(function(stream) {
                        stream.getTracks().forEach(function(track) { track.stop(); });
                        resolve('GRANTED');
                    })
                    .catch(function() { resolve('UNAVAILABLE'); });
            };

            if (!navigator.permissions || !navigator.permissions.query) {
                probeWithLiveAccess();
                return;
            }

            navigator.permissions.query({ name: 'microphone' })
                .then(function(permission) {
                    if (permission.state === 'granted') {
                        resolve('GRANTED');
                    } else if (permission.state === 'prompt') {
                        resolve('PROMPT');
                    } else {
                        resolve('UNAVAILABLE');
                    }
                })
                .catch(probeWithLiveAccess);
        })
    ,
    'com.exampia.core.ui.platform.jsKnownMicPermissionPromise' : () => 
        new Promise(function(resolve) {
            if (!navigator.permissions || !navigator.permissions.query) {
                resolve('UNKNOWN');
                return;
            }
            navigator.permissions.query({ name: 'microphone' })
                .then(function(permission) { resolve(permission.state === 'granted' ? 'GRANTED' : 'UNKNOWN'); })
                .catch(function() { resolve('UNKNOWN'); });
        })
    ,
    'com.exampia.core.ui.platform.jsRequestMicPromise' : () => 
        new Promise(function(resolve) {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                resolve('BLOCKED');
                return;
            }
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(function(stream) {
                    stream.getTracks().forEach(function(track) { track.stop(); });
                    resolve('GRANTED');
                })
                .catch(function(err) {
                    var isBlocked = err && (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError');
                    resolve(isBlocked ? 'BLOCKED' : 'DENIED');
                });
        })
    ,
    'com.exampia.core.ui.util.localDateIsoForEpochMillis' : (epochMillis, timeZoneId) => 
        (function() {
            const timeZone = timeZoneId === 'SYSTEM'
                ? new Intl.DateTimeFormat().resolvedOptions().timeZone
                : timeZoneId === 'Z' ? 'UTC' : timeZoneId;
            const parts = new Intl.DateTimeFormat('en-US-u-ca-iso8601-nu-latn', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone
            }).formatToParts(new Date(Number(epochMillis)));
            const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
            return values.year.padStart(4, '0') + '-' + values.month + '-' + values.day;
        })()
        ,
    'com.exampia.core.ui.util.formatPlatformDateTime' : (epochMillis, localDateIso, localeCode, timeZoneId, includeDate, includeTime, includeYear) => 
        (function() {
            const options = {};
            const timeZone = timeZoneId === 'SYSTEM'
                ? new Intl.DateTimeFormat().resolvedOptions().timeZone
                : timeZoneId === 'Z' ? 'UTC' : timeZoneId;
            let date;
            if (localDateIso) {
                const [year, month, day] = localDateIso.split('-').map(Number);
                const requestedDay = Date.UTC(year, month - 1, day);
                let timestamp = Date.UTC(year, month - 1, day, 12);
                const dateParts = value => {
                    const parts = new Intl.DateTimeFormat('en-US-u-ca-iso8601-nu-latn', {
                        year: 'numeric', month: '2-digit', day: '2-digit', timeZone
                    }).formatToParts(value);
                    return Object.fromEntries(parts.map(part => [part.type, part.value]));
                };
                for (let attempt = 0; attempt < 3; attempt++) {
                    const local = dateParts(new Date(timestamp));
                    const actualDay = Date.UTC(Number(local.year), Number(local.month) - 1, Number(local.day));
                    if (actualDay === requestedDay) break;
                    timestamp += requestedDay - actualDay;
                }
                date = new Date(timestamp);
            } else {
                date = new Date(Number(epochMillis));
            }
            if (includeDate) {
                options.month = 'short';
                options.day = 'numeric';
                if (includeYear) options.year = 'numeric';
            }
            if (includeTime) {
                options.hour = 'numeric';
                options.minute = '2-digit';
            }
            options.timeZone = timeZone;
            return new Intl.DateTimeFormat(localeCode || 'en', options).format(date);
        })()
        ,
    'com.exampia.feature.auth.ui.helper.cancelGoogleSignIn' : () => { if (window.__exampiaGoogleSignInCancel) window.__exampiaGoogleSignInCancel(); },
    'com.exampia.feature.auth.ui.helper.googleSignInPromise' : (clientId) => 
        new Promise(function(resolve) {
            var bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            var state = Array.from(bytes).map(function(b) { return b.toString(16).padStart(2, '0'); }).join('');
            var nonce = state;
            var redirectUri = window.location.origin + '/oauth_callback.html';
            var params = new URLSearchParams({
                client_id: clientId,
                redirect_uri: redirectUri,
                response_type: 'id_token',
                scope: 'openid email profile',
                nonce: nonce,
                state: state,
                prompt: 'select_account'
            });
            var authUrl = 'https://accounts.google.com/o/oauth2/v2/auth?' + params.toString();
            var width = 500, height = 620;
            var left = Math.round((window.screen.width - width) / 2);
            var top = Math.round((window.screen.height - height) / 2);
            var popup = window.open('about:blank', '_googleSignIn',
                'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',toolbar=no,menubar=no,scrollbars=yes');
            if (!popup) { resolve('__NO_CREDENTIALS__'); return; }

            var finished = false, channel = null, pollId = null, timeoutId = null;
            function finish(value) {
                if (finished) return;
                finished = true;
                window.removeEventListener('message', onMessage);
                clearTimeout(timeoutId);
                clearInterval(pollId);
                if (channel) channel.close();
                window.__exampiaGoogleSignInCancel = null;
                try { popup.close(); } catch (e) {}
                resolve(value);
            }
            function consume(data) {
                if (!data || data.type !== 'google_oauth_callback' || data.state !== state) return;
                finish(data.idToken || '__CANCELED__');
            }
            function onMessage(event) {
                if (event.origin === window.location.origin && event.source === popup) consume(event.data);
            }
            window.addEventListener('message', onMessage);
            if (typeof BroadcastChannel !== 'undefined') {
                channel = new BroadcastChannel('google_oauth_' + state);
                channel.onmessage = function(event) { consume(event.data); };
            }
            pollId = setInterval(function() { if (popup.closed) finish('__CANCELED__'); }, 500);
            timeoutId = setTimeout(function() { finish('__CANCELED__'); }, 120000);
            window.__exampiaGoogleSignInCancel = function() { finish('__CANCELED__'); };
            popup.location.replace(authUrl);
        })
        ,
    'com.exampia.feature.profile.ui.component.consent.setConsentDialogAccessibilityState' : (dialogId) => { 
            {
              window.__exampiaConsentDialogId = dialogId;
              window.dispatchEvent(new Event("exampia-consent-dialog-state-change"));
            }
         },
    'com.exampia.installConsentDialogAccessibilityBridge' : () => 
        {
          const applyDialogSemantics = (root) => {
            const apply = () => {
              const activeDialogId = window.__exampiaConsentDialogId;
              ["consent_banner_dialog", "consent_preferences_dialog"].forEach((id) => {
                const node = root.querySelector("#" + id);
                if (!node) return;
                if (id === activeDialogId) {
                  if (node.getAttribute("role") !== "dialog") node.setAttribute("role", "dialog");
                  if (node.getAttribute("aria-modal") !== "true") node.setAttribute("aria-modal", "true");
                  node.removeAttribute("aria-hidden");
                } else {
                  if (node.getAttribute("aria-hidden") !== "true") node.setAttribute("aria-hidden", "true");
                  node.removeAttribute("aria-modal");
                }
              });
              const isConsentDialogOpen = activeDialogId === "consent_banner_dialog" || activeDialogId === "consent_preferences_dialog";
              document.querySelectorAll('a[id^="profile-link-"]').forEach((anchor) => {
                if (isConsentDialogOpen) {
                  anchor.setAttribute("inert", "");
                  anchor.setAttribute("aria-hidden", "true");
                  anchor.setAttribute("tabindex", "-1");
                  anchor.style.pointerEvents = "none";
                } else {
                  anchor.removeAttribute("inert");
                  anchor.removeAttribute("aria-hidden");
                  anchor.setAttribute("tabindex", "0");
                  anchor.style.pointerEvents = "";
                }
              });
            };
            const observer = new MutationObserver(apply);
            observer.observe(root, {
              subtree: true,
              childList: true,
              attributes: true,
              attributeFilter: ["role", "aria-hidden"]
            });
            const composeHost = document.getElementById("composeApp");
            if (composeHost) {
              const linkOverlayObserver = new MutationObserver(apply);
              linkOverlayObserver.observe(composeHost, { subtree: true, childList: true });
              window.__exampiaConsentLinkOverlayObserver = linkOverlayObserver;
            }
            window.addEventListener("exampia-consent-dialog-state-change", apply);
            apply();
            window.__exampiaConsentDialogSemanticsObserver = observer;
          };

          const findSemanticsRoot = () => {
            const shadowHost = document.querySelector("#composeApp > div > div");
            return shadowHost && shadowHost.shadowRoot
              ? shadowHost.shadowRoot.getElementById("cmp_a11y_root")
              : null;
          };
          const root = findSemanticsRoot();
          if (root) {
            applyDialogSemantics(root);
          } else {
            const rootObserver = new MutationObserver((_, observer) => {
              const semanticsRoot = findSemanticsRoot();
              if (semanticsRoot) {
                observer.disconnect();
                applyDialogSemantics(semanticsRoot);
              }
            });
            rootObserver.observe(document.documentElement, { subtree: true, childList: true });
            window.__exampiaConsentDialogBootstrapObserver = rootObserver;
          }
        }
    ,
    'com.exampia.auth.provider.prepareProviderPopup' : () => {
        if (!window.__exampiaProviderPopup || window.__exampiaProviderPopup.closed) {
            window.__exampiaProviderPopup = window.open('about:blank', '_exampiaProvider', 'width=500,height=650');
        }
    },
    'com.exampia.auth.provider.cancelProviderPopup' : () => {
        if (window.__exampiaProviderCancel) window.__exampiaProviderCancel();
        else if (window.__exampiaProviderPopup) window.__exampiaProviderPopup.close();
        window.__exampiaProviderPopup = null;
    },
    'com.exampia.auth.provider.providerOAuthPromise' : (provider, clientId, nonce) => 
        new Promise(function(resolve) {
            var popup = window.__exampiaProviderPopup;
            if (!popup || popup.closed) popup = window.open('about:blank', '_exampiaProvider', 'width=500,height=650');
            if (!popup || clientId === 'FACEBOOK_APP_ID') {
                if (popup) popup.close();
                window.__exampiaProviderPopup = null;
                resolve('__UNAVAILABLE__'); return;
            }
            var bytes = new Uint8Array(32); crypto.getRandomValues(bytes);
            var state = Array.from(bytes).map(function(b) { return b.toString(16).padStart(2, '0'); }).join('');
            var redirect = window.location.origin + '/provider_callback.html';
            var params = new URLSearchParams({client_id: clientId, redirect_uri: redirect, state: state});
            if (provider === 'google') {
                params.set('response_type', 'id_token'); params.set('scope', 'openid email profile');
                params.set('nonce', nonce); params.set('prompt', 'select_account');
            } else { params.set('response_type', 'token'); params.set('scope', 'public_profile,email'); }
            var endpoint = provider === 'google' ? 'https://accounts.google.com/o/oauth2/v2/auth?' : 'https://www.facebook.com/v22.0/dialog/oauth?';
            var done = false, channel = null;
            function finish(value) {
                if (done) return; done = true;
                window.removeEventListener('message', onMessage); clearInterval(poll); clearTimeout(timeout);
                if (channel) channel.close(); popup.close();
                window.__exampiaProviderPopup = null; window.__exampiaProviderCancel = null;
                resolve(value);
            }
            function consume(data) {
                if (!data || data.type !== 'exampia_provider_callback' || data.state !== state) return;
                var token = provider === 'google' ? data.idToken : data.accessToken;
                finish(token || (data.error === 'access_denied' ? '__CANCELLED__' : '__UNAVAILABLE__'));
            }
            function onMessage(event) {
                if (event.origin === window.location.origin && event.source === popup) consume(event.data);
            }
            window.addEventListener('message', onMessage);
            if (typeof BroadcastChannel !== 'undefined') {
                channel = new BroadcastChannel('exampia_provider_' + state);
                channel.onmessage = function(event) { consume(event.data); };
            }
            var poll = setInterval(function() { if (popup.closed) finish('__CANCELLED__'); }, 500);
            var timeout = setTimeout(function() { finish('__CANCELLED__'); }, 120000);
            window.__exampiaProviderCancel = function() { finish('__CANCELLED__'); };
            popup.location.replace(endpoint + params.toString());
        })
    ,
    'com.exampia.di.isWebDriverBrowser' : () => window.navigator.webdriver === true,
    'com.exampia.di.encodeConsentCookieValue' : (value) => encodeURIComponent(value),
    'com.exampia.di.decodeConsentCookieValue' : (value) => decodeURIComponent(value),
    'com.exampia.nav.deeplink.pushBrowserHistoryState' : (index, url) => window.history.pushState({ __exampiaHistoryIndex: index }, '', url),
    'com.exampia.nav.deeplink.replaceBrowserHistoryState' : (index, url) => window.history.replaceState({ __exampiaHistoryIndex: index }, '', url),
    'com.exampia.nav.deeplink.readBrowserHistoryIndex' : () => 
        (function(state) {
            var index = state && state.__exampiaHistoryIndex;
            return Number.isInteger(index) ? index : null;
        })(window.history.state)
    ,
    'com.exampia.nav.deeplink.readNavigationApiIndex' : () => 
        (function(navigation) {
            var entry = navigation && navigation.currentEntry;
            var index = entry && entry.index;
            return Number.isInteger(index) && index >= 0 ? index : null;
        })(window.navigation)

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    